import * as tslib_1 from "tslib";
/**
 *    Copyright 2018 the original author or authors
 *
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 *
 *        http://www.apache.org/licenses/LICENSE-2.0
 *
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 */
import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { ModelMetaService } from '../../common';
import { ExtendzApiConfig } from '../models';
var ApiRootService = /** @class */ (function () {
    function ApiRootService(apiConfig, iconRegistry, sanitizer, modelService) {
        this.apiConfig = apiConfig;
        this.iconRegistry = iconRegistry;
        this.sanitizer = sanitizer;
        this.modelService = modelService;
        this.iconRegistry.addSvgIconSetInNamespace('api-root', sanitizer.bypassSecurityTrustResourceUrl(this.apiConfig.svgIconSet));
    } // constructor()
    ApiRootService.prototype.getRoot = function () {
        return this.modelService.getModels();
    };
    ApiRootService = tslib_1.__decorate([
        Injectable(),
        tslib_1.__metadata("design:paramtypes", [ExtendzApiConfig,
            MatIconRegistry,
            DomSanitizer,
            ModelMetaService])
    ], ApiRootService);
    return ApiRootService;
}()); // class
export { ApiRootService };
//# sourceMappingURL=api-root.service.js.map